module.exports = __webpack_public_path__ + "img/layout_01_hover.0f29e06e.svg";